import script from "./fromThirdPay.vue?vue&type=script&setup=true&lang=js"
export * from "./fromThirdPay.vue?vue&type=script&setup=true&lang=js"

import "./fromThirdPay.vue?vue&type=style&index=0&id=97f6c6bc&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97f6c6bc"]])

export default __exports__